BinderResults = window.BinderResults = (function () {
    var selectors = Results.selectors;
    var vmSelectedClass = 'm-selected';

    function getUtcTimeStamp(timeStamp) {
        return timeStamp - globalAppSettings.timeOffset * 60 * 1000;
    }

    var bindUI = function () {
        var body = app.body;

        //--- v2.0 start -------------------------------------------------------

        // Change time period v2.0
        body.on('click', selectors.setPeriod, function () {
            app.enableLoading();
            app.VerticalMenu.dispose();

            var startDate = new Date(getUtcTimeStamp(parseInt($(selectors.dateStart).attr('data-timestamp'))));
            var endDate = new Date(getUtcTimeStamp(parseInt($(selectors.dateEnd).attr('data-timestamp'))));

            Ajax.postJson("/Results/SetTimePeriod", {
                data: {
                    start: startDate.toISOString(),
                    end: endDate.toISOString()
                },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.VerticalMenu.init();
                    app.disableLoading();
                }
            });
        });
        //
        // Set today v2.0
        body.on('click', selectors.setToday, function () {
            var date = new Date();
            $(selectors.dateStart).datepicker('setDate', date);
            $(selectors.dateEnd).datepicker('option', 'maxDate', date).datepicker('setDate', date);
            $(selectors.setPeriod).click();
            return false;
        });

        // toggle SportFilterItem v2.0
        body.on('click', selectors.vmSportsFilterItem + '[data-id]', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            var container = $(this),
                id = container.data('id');

            var isAllChecked = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem + ':not(.m-selected)').length > 0 ? false : true;
            var filterItemsLength = $(selectors.vmSportsFilterItem).length;

            if (isAllChecked && filterItemsLength > 1) {
                container.addClass('m-loading');
                Ajax.postJson("/Results/EnableOnlyOneItem", {
                    data: {
                        id: id
                    },
                    doCallAjaxViewParsers: false,
                    success: function (resp) {
                        $(selectors.vmSelectAll).prop('checked', false);
                        $(selectors.sportsBlock).remove();
                        $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem).removeClass('m-selected');
                        container.addClass('m-selected');
                        insertTable(resp.html, container);
                        container.removeClass('m-loading');
                    }
                });
            } else {
                toggleSportsFilterItem(id, container);
            }

            return false;
        });

        // toggle SportFilter v2.0
        body.on('click', selectors.vmSelectAll, function () {
            const selectedClass = 'm-selected';
            var that = $(this),
                removingAll = !that.prop('checked'),
                allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem);

            that.parent().parent().addClass('m-loading');
            Ajax.postJson("/Results/ToggleSportFilter", {
                doCallAjaxViewParsers: false,
                success: function () {
                    if (removingAll) {
                        $(selectors.sportsBlock).remove();
                        that.prop('checked', false);
                        allItems.removeClass(selectedClass);
                    }
                    else {
                        that.prop('checked', true);
                        allItems.addClass(selectedClass);
                    }
                    ($(selectors.sportsBlock).length === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');

                    that.parent().parent().removeClass('m-loading');
                }
            });
            return false;
        });

        // Search v2.0
        var lastQuery = '';
        body.on('keypress', selectors.searchInput, function (e) {
            if (e.which == 13) {
                var query = $(this).val();
                if (query.trim() === lastQuery)
                    return false;
                lastQuery = query.trim();
                app.enableLoading();
                Ajax.postJson("/Results/Search", {
                    data: { query: query, enter: e.successHandler ? false : true },
                    doCallAjaxViewParsers: false,
                    success: function (resp) {
                        app.disableLoading();
                        if (e.successHandler) {
                            e.successHandler(resp, query);
                        } else {
                            window.Search.hide();
                        }
                    }
                });
                return false;
            }
        });

        //Expand Details v2.0
        body.on('click', selectors.eventExpandButton, function () {
            $(this).closest(selectors.event).toggleClass('m-expanded');
        });

        // Toggle SportTable v2.5
        body.on('click', selectors.tbExpandSport, function () {
            var that = $(this).closest('.events-table'),
                id = that.data('id');

            that.addClass('m-loading');
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/results/CollapseNode', {
                    data: { id: id },
                    doCallAjaxViewParsers: false,
                    success: function () {
                        that.removeClass('m-expanded').addClass('m-collapsed');
                        app.ModeTablePrematch.collapseTable(id);
                        that.removeClass('m-loading');
                    }
                });
                return false;
            }

            Ajax.postJson('/results/ExpandSportsTable', {
                data: { id: id },
                success: function () {
                    app.ModeTablePrematch.updateTable(id);
                    that.removeClass('m-loading');
                }
            });
            return false;
        });

        // Toggle League v2.5
        body.on('click', selectors.tbLeague, function () {
            var that = $(this).closest('.events-table__group'),
                id = that.data('id'),
                tId = that.closest(selectors.tbSport).data('id');

            that.addClass('m-loading');
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/results/CollapseNode', {
                    data: {
                        id: id
                    },
                    doCallAjaxViewParsers: false,
                    success: function () {
                        that.removeClass('m-expanded').addClass('m-collapsed');
                        that.find(selectors.tbLeagueBody).remove();
                        app.ModeTablePrematch.shrinkTable(tId);
                        that.removeClass('m-loading');
                    }
                });
                return false;
            }
            Ajax.postJson('/results/ExpandLeague', {
                data: { id: id },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTablePrematch.extendTable(tId);
                    app.disableLoading();
                }
            });
            return false;
        });

        ConfirmButton.init(
            selectors.collapseAllNodes,
            function () { app.enableLoading(); },
            '/results/CollapseAllNodes',
            function () { app.ModeTablePrematch.update(); app.disableLoading(); }
        );
    };

    var unBindUI = function() {
        app.body.off('click', selectors.setPeriod)
            .off('click', selectors.setToday)
            .off('click', selectors.vmSportsFilterItem + '[data-id]')
            .off('click', selectors.vmSelectAll)
            .off('keyup', selectors.searchInput)
            .off('click', selectors.eventExpandButton)
            .off('click', selectors.tbExpandSport)
            .off('click', selectors.tbLeague);
        ConfirmButton.dispose(selectors.collapseAllNodes);
    };

    var toggleSportsFilterItem = function (id, sportsFilterItemContainer, callback) {
        var removing = sportsFilterItemContainer.hasClass(vmSelectedClass),
            allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem),
            selectAllbtn = $(selectors.vmSelectAll);

        sportsFilterItemContainer.addClass('m-loading');
        Ajax.postJson("/Results/ToggleSportFilterItem", {
            data: {
                id: id
            },
            doCallAjaxViewParsers: false,
            success: function (resp) {
                if (removing) {
                    $(selectors.sportsBlock + '[data-id=' + id + ']').remove();
                    sportsFilterItemContainer.removeClass(vmSelectedClass);
                }
                else {
                    insertTable(resp.html, sportsFilterItemContainer);
                    sportsFilterItemContainer.addClass(vmSelectedClass);
                }

                selectAllbtn.prop('checked', (allItems.filter('.' + vmSelectedClass).length === allItems.length));
                ($(selectors.sportsBlock).length === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');

                sportsFilterItemContainer.removeClass('m-loading');

                if (callback) callback();
            }
        });
    }

    var insertTable = function (html, sportsFilterItemContainer) {
        var openedTableIds = $(selectors.sportsBlock).toArray().map(function (x) {
            return $(x).data('id');
        });

        var insertAfterId = sportsFilterItemContainer.prevAll('.' + vmSelectedClass).toArray()
            .map(function (x) {
                return $(x).data('id');
            })
            .filter(function (x) {
                return openedTableIds.indexOf(x) !== -1;
            })[0];

        if (insertAfterId !== undefined) {
            var insertAfterTable = $(selectors.sportsBlock + '[data-id=' + insertAfterId + ']');
            if (insertAfterTable.length !== 0)
                $(html).insertAfter(insertAfterTable);
            else
                $(selectors.betPlace).prepend(html);
        }
        else
            $(selectors.betPlace).prepend(html);
    }

    var scrollToTable = function (id) {
        var table = $(selectors.sportsBlock).filter('[data-id="' + id + '"]');
        var pageContentMargin = 20;

        if (table.length > 0) {
            $(selectors.pageScrollbarContainer).scrollTop(table.position().top + pageContentMargin);
        }
    }

    var bind = function(justLoaded) { bindUI(); }
    var unBind = function() { unBindUI(); }

    var scrollToEvent = function(id) {
        app.enableLoading();
        query = $(selectors.searchInput).val();
        Ajax.postJson("/Results/Search", {
            data: { query: query, enter: true },
            doCallAjaxViewParsers: false,
            success: function () {
                window.Search.hide();
                lastQuery = query.trim();
                app.disableLoading();
                var event = $(selectors.event).filter('[data-id="' + id + '"]');
                var pageContentMargin = 20;

                if (event.length > 0) {
                    $(selectors.pageScrollbarContainer).scrollTop(event.position().top - pageContentMargin);
                    var eventid = event.find(".results-event__number");
                    eventid.text("");
                    eventid.append($('<mark>' + id + '</mark>'));
                }
            }
        });
    }

    return {
        bind: bind,
        unBind: unBind,
        name: 'BinderResults',
        url: '/Results/GetViewSet',
        scrollToEvent: scrollToEvent
    }
}());

//-----------------------------------

ScopeResults = (function () {
    function init() {
        app.VerticalMenu.init();
        app.VerticalMenu.show();
        Results.init();
        app.Search.bindCloseButtonHandler();
    }

    function dispose() {
        Results.dispose();
        app.VerticalMenu.dispose();
        app.Search.unbindCloseButtonHandler();
    }

    var start = function (justLoaded) { init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopeResults',
        url: 'RESULTS',
        title: Localization.getString('Shared.Results','Результаты'),
        isLayoutRightColumnVisible: false
    };
}());